module.exports = __webpack_public_path__ + "static/media/IconMore.aaef852b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/IconMore.svg
// module id = 944
// module chunks = 0